import { render, staticRenderFns } from "./ClinicasActivas.vue?vue&type=template&id=84bd540c"
import script from "./ClinicasActivas.vue?vue&type=script&lang=js"
export * from "./ClinicasActivas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports